namespace $ {

	$mol_style_define( $bog_ui_app_badge, {

		padding: $mol_gap.block,

		Description: {
			color: $mol_theme.shade,
			padding: {
				bottom: '1rem',
			},
		},

		Variants_title: {
			font: {
				size: '1.125rem',
				weight: 'bold',
			},
			padding: {
				top: '.5rem',
				bottom: '.75rem',
			},
		},

		Variants: {
			flex: {
				wrap: 'wrap',
			},
			gap: '.75rem',
			align: {
				items: 'center',
			},
		},

	} )

}
